import { render, staticRenderFns } from "./priceTextBoxComponent.vue?vue&type=template&id=f5042b66"
import script from "./priceTextBoxComponent.vue?vue&type=script&lang=js"
export * from "./priceTextBoxComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports